/*!
 * Copyright © 2021. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum ESpeedLimitOption {
  None = 1,
  IncludeRoadSpeed = 2,
  IncludePostedSpeed = 4
}
